/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  userDetailsActions.ts
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali (H175591)
 *
 * On            : Sep 13, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Madhu Gali (H175591)
 * On            : Sep 13, 2019
 * Description   : ASDS-1170: User email automatically populated.
 *
 * By            	: Madhu Gali
 * On            	:  Dec 18, 2019
 * Description      : ASDS-584
 *
 * By            : Madhu Gali - H175591
 * On            : Jan 10, 2019
 * Description   : ASDS-2152
 *
 * By            : Madhu Gali - H175591
 * On            : Feb 19, 2020
 * Description   : ASDS-2355
 *
 * By            : Suresh Jaladi - E807958
 * On            : Mar 11, 2020
 * Description   : ASDS-1766
 *
 * By            : H224423
 * On            : Mar 23, 2020
 * Description   : ASDS-1052 - Forge Header Logout Functionality. Added method to reset user validation data.
 *
 * By            : E807958
 * On            : Mar 30, 2020
 * Description   : ASDS-1763
 *
 * By            : H224423
 * On            : 09 Apr, 2020
 * Description   : ASDS-2497 APU SIT Fixes. Added reset condition and erro handling.
 *
 * By            : H422335
 * On            : Oct 27, 2020
 * Description   : ASDS-3269 Migration of backend URLs to Forge endpoints
 ******************************************************************************/

import Action from '../actions/Action';
import CheckoutActionConstants from '../../constants/checkoutActionConstants';
import ActionConstants from '../action-constants';
import {
  getProperty,
  AccessCodeInf,
  AccessTokenInf,
  handleUnauthorizedUser,
  removeBrowserStorage,
  getAccessToken
} from '../../../../utils/util';
import { CheckoutServiceURL } from '../../constants/checkout-constants';
import axios from 'axios';
import { handleResponse } from '../../API/apiUtils';
import { logError } from '../../../../utils/console-utility';
import UserDetailsAPI from '../../API/user-details-api';
import { AppConsts } from 'modules/checkout/constants/server-constants';
import { getForgeTokenInfo, updateForgeTokenInfo } from 'modules/checkout/utils/util';

/**
 * @author H175591
 * @description This action class consists of all the actions that deal with user data validation.
 */
class UserValidationAction extends Action {
  static checkSFDCCaseStatus(userID) {
    return async dispatch => {
      await UserDetailsAPI.checkSFDCCaseStatus(userID)
        .then(data => {
          dispatch(UserValidationAction.setSFDCCaseStatus(data));
        })
        .catch(error => {
          logError(
            'Error occurred in retrieveing SFDC case information',
            error
          );
        });
    };
  }

  static setSFDCCaseStatus = data => {
    let dataToStore: any = {};
    if (data === null) {
      dataToStore = data;
    } else {
      dataToStore.results = data.address;
    }
    return {
      type: CheckoutActionConstants.SET_SFDC_CASE_STATUS,
      payload: {
        response: dataToStore
      }
    };
  };

  static getForgeAccessToken(userSessionObject: AccessCodeInf) {
    return async dispatch => {
      const URL: string = getProperty(CheckoutServiceURL.ACCESS_TOKEN_URL);

      const bodyFormData = new FormData();
      bodyFormData.append("grant_type", AppConsts.authorization_code);
      bodyFormData.append("code", userSessionObject.code);
      bodyFormData.append(
        "redirect_uri",
        getProperty(CheckoutServiceURL.FORGE_ADS_REDIRECT_URL)
      );
      bodyFormData.append("client_id", AppConsts.clientId);

      await axios({
        method: "post",
        url: URL,
        data: bodyFormData,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(response => {
          const accessTokenObj: AccessTokenInf = handleResponse(response);
          const reqData = {
            accessTokenObj,
            accessCodeObj: userSessionObject,
            isForgeEnv: true
          };
          dispatch(UserValidationAction.setUserAccessCodeAndTokenResp(reqData));
        })
        .catch(() => {
          handleUnauthorizedUser();
        });
    };
  }

  static setUserAccessCodeAndTokenResp(response) {
    return {
      type: CheckoutActionConstants.SET_USER_ACCESS_INFO,
      payload: {
        response
      }
    };
  }

  static getLoggedInForgeUserInfo() {
    return async (dispatch, getState) => {
      const URL: string = getProperty(CheckoutServiceURL.USERINFO_URL);
      const accessTokenObj = getState().userValidationData.payload
        .userSessionInfo.accessToken;
      await axios
        .get(URL, {
          headers: {
            Authorization: `${accessTokenObj.token_type} ${accessTokenObj.access_token}`
          }
        })
        .then(response => {
          let data = handleResponse(response);
          dispatch(UserValidationAction.setForgeUserInfo(data));
        })
        .catch(error => {
          logError('Error in fetching user info', error);
          if (error.response.status === 401){
            return new Promise(function (resolve, reject) {

              return UserValidationAction.refreshToken().then(_ => {
                  let token = {
                      toString() {
                          return getAccessToken();
                      }
                  };
                  error.config.headers['Authorization'] = token;
                  resolve(axios(error.config));
              }).catch((err) => {
                  reject(err);
              });
          });
          } else {
            throw new Error(error);
          }
        });
    };
  }

  static refreshToken = async () => {
    console.log('refreshing the token');
    const bodyFormData = new FormData();
    bodyFormData.append('grant_type', 'refresh_token');
    bodyFormData.append('refresh_token', getForgeTokenInfo('refresh_token'));
    bodyFormData.append('redirect_uri', getProperty(CheckoutServiceURL.FORGE_ADS_REDIRECT_URL));
    bodyFormData.append('client_id', AppConsts.clientId);
    await axios({
      method: 'post',
      url: getProperty(CheckoutServiceURL.ACCESS_TOKEN_URL),
      data: bodyFormData,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then(response => {
      const access_token = response.data.access_token;
      const refresh_token = response.data.refresh_token;
      updateForgeTokenInfo(access_token, refresh_token);
    })
    .catch(() => {
      removeBrowserStorage();
      window.location.href = getProperty(CheckoutServiceURL.FORGE_ADS_REDIRECT_URL);
    });
}

  static setForgeUserInfo(response) {
    return {
      type: CheckoutActionConstants.SET_LOGGED_IN_USER_INFO,
      payload: {
        response
      }
    };
  }
  // userId no longer needed to check access after migration to Forge. Will check against authorization header
  // static checkASDSAccess(userID: string) {
  static checkASDSAccess() {
    return async dispatch => {
      // resetting existing data - select account and user address details
      dispatch(UserValidationAction.setSFDCCaseStatus(null));
      dispatch({
        type: ActionConstants.RESET_SELECT_ACCOUNT,
        payload: {}
      });

      await UserDetailsAPI.hasASDSAccess()
        .then(response => {
          dispatch(UserValidationAction.setAsdsAccess(response));
        })
        .catch(error => {
          logError('Error occurred while verifying user', error);
          throw new Error('check access error');
        });
    };
  }

  static setAsdsAccess(response) {
    return {
      type: CheckoutActionConstants.SET_ASDS_ACCESS_INFO,
      payload: response
    };
  }

  static checkUserRole() {
    return async dispatch => {
      await UserDetailsAPI.checkForUserRole()
      .then(response => {
        dispatch(UserValidationAction.setUserRole(response));
      })
      .catch(error => {
        logError('Error occurred while verifying user', error);
        throw new Error('check access error');
      });
    }
  }

  static setUserRole(response) {
    return {
      type: CheckoutActionConstants.SET_ASDS_USER_ROLE,
      payload: response
    };
  }

  static resetUserInfo = () => {
    return {
      type: CheckoutActionConstants.RESET_USER_INFO,
      payload: {}
    };
  }
}

export default UserValidationAction;
